/** Vanity domain for the baked static player (vplay) — pretty root URLs. */
export const VPLAY_CDN = 'https://play.4klabs.ai';

/** URL of a share's baked static player bundle. */
export const vplayUrl = (shareToken: string): string => `${VPLAY_CDN}/${shareToken}/`;

/**
 * The page to embed for a share. play.4klabs.ai serves only prod bakes (each at its pinned
 * runtime) and play-beta.4klabs.ai beta's, so an address on either play host is embedded as the API
 * gives it; an older beta bake under /vplay-beta/ on the CDN is embedded as given too.
 */
export const playerUrl = (shareToken: string, staticBundleUrl?: string | null, search = ''): string => {
  const onPlayHost = !!staticBundleUrl && /^https:\/\/play(-beta)?\.4klabs\.ai\//.test(staticBundleUrl);
  const base = onPlayHost || staticBundleUrl?.includes('/vplay-beta/') ? staticBundleUrl! : vplayUrl(shareToken);
  return base + launchSearch(search);
};

/**
 * The share page's query string as the player's launch context (?actor=, ?reg=, …): the player
 * reads it from its own URL, so the embedding page must forward it. `review` is the page's own.
 */
function launchSearch(search: string): string {
  const params = new URLSearchParams(search);
  params.delete('review');
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

const VIEWER_ID = /^[A-Za-z0-9._-]{1,64}$/;

/** Why `id` cannot name a viewer in a link, or null when it can. The id sits in the url, so never a name or email. */
export function viewerIdProblem(id: string): string | null {
  if (id.includes('@')) return 'That looks like an email. Use an id you can look up instead, like a student number.';
  if (!VIEWER_ID.test(id)) return 'Use letters, numbers, dots, dashes or underscores, up to 64 characters.';
  return null;
}

/** The share link for one viewer: Analytics lists this link's views under `id` (?actor=). */
export function viewerLink(url: string, id: string): string {
  const link = new URL(url);
  link.searchParams.set('actor', id);
  return link.toString();
}
